import React, { useState } from "react";
import { TextField, Autocomplete } from "@mui/material";
import { useQuery } from "@apollo/client";
//src
import "../../Style/dialogstyle.scss";
import { SELECT_UNIT_BYID_MATERIAL } from "../../Schema/Reqpurchase";

export default function SelectMaterailUnit({
  eachList,
  handleUpdateValue,
  disabled,
  readOnly,
}) {
  
  const [listMaterialUnitOptions, setMeterialUnitOptions] = useState([]);
  //select Material
  const { refetch: refectUnitByMaterialID } = useQuery(
    SELECT_UNIT_BYID_MATERIAL,
    {
      variables: {
        materialId: eachList?.materialId?.id,
      },
      onCompleted: ({ selectUnitByMaterialId }) => {
        // console.log("selectUnitByMaterialId::", selectUnitByMaterialId)
        const Data = selectUnitByMaterialId?.map((e) => {
          return {
            id: e?._id,
            title: e?.unitId?.unitKhName,
            imageSrc: e?.imageSrc,
            unitPrice: e?.costPerUnit,
          };
        });
        setMeterialUnitOptions(Data);
      },
      onError: (error) => {
        // setLoading(true)
        console.log(error?.message);
      },
    }
  );
  return (
    <Autocomplete
      readOnly={readOnly}
      value={eachList.listMaterialUnitId}
      options={listMaterialUnitOptions}
      onChange={(event, val) =>
        handleUpdateValue(eachList.key, val, "listMaterialUnitId")
      }
      getOptionLabel={(option) =>
        option?.title === undefined ? "ជ្រើសរើសខ្នាត" : option?.title
      }
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder={"ជ្រើសរើសខ្នាត"}
          disabled={disabled}
        />
      )}
    />
  );
}
